import React, { useState, useEffect } from 'react';
import './SearchPost.css';
import axios from 'axios';
//import { toast } from 'react-toastify';

function SearchPost() {
    const [data, setData] = useState([]);
    const [key, setKey] = useState("");

    useEffect(() => {
        axios.get("https://jsonplaceholder.typicode.com/posts")
            .then((response) => {
                setData(response.data);


            })
            .catch(error => console.log(error));
    }, []);

    return (
        <div className='post'>
            <input type="text" placeholder='Enter id' value={key}
                onChange={(e) => setKey(e.target.value)} />
            {data && data.map((i) => {
                if (i.id == key) {
                    //toast("success search");
                    return (
                        <div key={i.id}>

                            <h2>{i.title}</h2>
                            <p>{i.body}</p>
                        </div>
                    )
                } else {
                    return (<div></div>)
                }
            })}
        </div>
    );
}
export default SearchPost;